import EngagementToolCommon from "./engagement-tool-common";
import ICEInvestmentIntegration from "./ice-investment-integration";
import { CommonHelper } from "../helpers";
import { mapGetters } from "vuex";
import { SET_INVESTMENT_CHART_MODEL } from "../helpers/vuex-constants";
import { GET_INVESTMENT_CHART_MODEL } from "../helpers/vuex-constants";
import { AdvanceInvestmentFilter } from "../helpers/constant";

import { mapActions } from "vuex";
export default {
  data() {
    return {
      chartContainer: "chart-container",
      isNotShowGraph: true,
      chartData: {
        areaChart0: [],
        barChart1: [],
        barChart2: [],
      },

      contentInfo: {
        chartTabContent: [
          {
            text: "Balance",
            id: "balanceGraph",
            active: true,
          },
          {
            text: "Contribution & Withdrawals",
            id: "contributionWithdrawalGraph",
            active: false,
          },
          {
            text: "Return & Fees",
            id: "ReturnFeesGraph",
            active: false,
          },
          {
            text: "Timeline",
            id: "timelineChart",
            active: false,
          },
        ],
      },
      selectedChartComponent: "chart-area",
      chartProperties: {},
      chartGraphData: [],
      selectedTabComponent: "balanceGraph",
    };
  },
  mixins: [EngagementToolCommon, ICEInvestmentIntegration],

  computed: {
    projectionYear() {
      return this.baselineData.projectionYear;
    },
    barChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 20],
        domainY: [0, 600000],
        tickQuantityY: 5,
        color: ["#1f55af", "#f4c508"],
        legendItems: ["Principal", "Interest"],
        yAxisLabel: "Repayment Amount",
        legendKeyType: "bar",
        areaLegendKey: "bar",
        currencyFormat: ".2s",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },

    areaChartProperties() {
      return {
        rangeX: [0, 1000],
        rangeY: [300, 0],
        domainX: [0, 2, 4, 6, 8, 10],
        domainY: [0, 600000],
        tickQuantityY: 5,
        areaLegendItems: "Loan",
        areaLegendKey: "bar",
        lineChartColor: "#2056af",
        currencyFormat: ".2s",
        yAxisLabel: "Loan Balance",
        height: 300,
        tickX: 0,
        axisLeftWidth: 75,
        axisRightWidth: 75,
      };
    },
    timeSeriesChartProperties() {
      return {
        domainX: this.getTimeSeriesXAxisData(this.baselineData.projectionYear), // [2020, 2055],
        color: ["#e5e5e5", "#1f55af"],
        legendKeyType: "bar",
        height: 10,
        tooltipWidth: 100,
        legendItems: this.legendItems,
        axisLeftWidth: 0,
        axisRightWidth: 0,
      };
    },
    ...mapGetters("investment", {
      projectionModel: GET_INVESTMENT_CHART_MODEL,
    }),
  },
  methods: {
    ...mapActions("investment", {
      setInvestmentChartModel: SET_INVESTMENT_CHART_MODEL,
    }),
    removeRow() {
      this.getinsertEmptyRows(this.rows);
    },
    RemoveError(Errors, typeid) {
      if (typeid == AdvanceInvestmentFilter.Return) {
        Errors["Return"] = [];
      } else if (typeid == AdvanceInvestmentFilter.Contribution) {
        Errors["Contribution"] = [];
      } else if (typeid == AdvanceInvestmentFilter.Withdrawal) {
        Errors["Withdrawal"] = [];
      } else if (typeid == AdvanceInvestmentFilter.Maturity) {
        Errors["Maturity"] = [];
      } else {
        Errors["MarketCrash"] = [];
      }
    },
    PushErrors(Errors, typeid, subType, error) {
      if (typeid == AdvanceInvestmentFilter.Return) {
        Errors.Return.push({
          type: subType,
          error: error,
        });
      } else if (typeid == AdvanceInvestmentFilter.Contribution) {
        Errors.Contribution.push({
          type: subType,
          error: error,
        });
      } else if (typeid == AdvanceInvestmentFilter.Withdrawal) {
        Errors.Withdrawal.push({
          type: subType,
          error: error,
        });
      } else if (typeid == AdvanceInvestmentFilter.Maturity) {
        Errors.Maturity.push({
          type: subType,
          error: error,
        });
      } else {
        Errors.MarketCrash.push({
          type: subType,
          error: error,
        });
      }
    },
    SetErrors(row, key, IsError, ErrorText = [""]) {
      row[key].IsError = IsError;
      row[key].ErrorText = ErrorText;
    },
    IsAnyInvOptionHaveInvalidData(errorLoanOption) {
      if (errorLoanOption.Return.length > 0) {
        this.$emit("openErrorTab", AdvanceInvestmentFilter.Return);
        return true;
      } else if (errorLoanOption.Contribution.length > 0) {
        this.$emit("openErrorTab", AdvanceInvestmentFilter.Contribution);
        return true;
      } else if (errorLoanOption.Withdrawal.length > 0) {
        this.$emit("openErrorTab", AdvanceInvestmentFilter.Withdrawal);
        return true;
      } else if (errorLoanOption.MarketCrash.length > 0) {
        this.$emit("openErrorTab", AdvanceInvestmentFilter.MarketCrash);
        return true;
      } else {
        return false;
      }
    },
    validations(tabdata, typeid) {
      let fields = this.singleHeadingOptions;
      let headers = this.headers;
      let rows = [];
      rows = tabdata.filter((sr) => sr.typeId.value == typeid);

      // let filteredrows = [];

      let blankdataError = false;
      let hasRangeError = false;

      let Errors = {
        hasErrors: false,
        Return: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Return
          : [],
        Contribution: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Contribution
          : [],
        Withdrawal: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Withdrawal
          : [],
        Maturity: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.Maturity
          : [],
        MarketCrash: this.baselineFilterObject.Errors
          ? this.baselineFilterObject.Errors.MarketCrash
          : [],
      };
      if (rows.length > 0 && headers) {
        //  let overlapvalidations = false;
        // for (let f = 0; f < fields.length; f++) {
        //   filteredrows = rows.filter((x) => x.subTypeId.value == fields[f].key);
        //   overlapvalidations = fields[f].overlapvalidations;
        this.RemoveError(Errors, typeid);

        for (let i = 0; i < rows.length; i++) {
          let subType = rows[i].subTypeId.value;
          let startMonth = "",
            startYear = "",
            endMonth = "",
            endYear = "";
          for (
            let h = 0;
            h < headers.filter((x) => x.type != "Icon").length;
            h++
          ) {
            let headername = headers[h].key;
            if (headername == "startDate") {
              startMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].startDate.value
              );
              startYear = CommonHelper.getYearfromMonthYear(
                rows[i].startDate.value
              );
            }
            if (headername == "endDate") {
              endMonth = CommonHelper.getMonthfromMonthYear(
                rows[i].endDate.value
              );
              endYear = CommonHelper.getYearfromMonthYear(
                rows[i].endDate.value
              );
            }
            if (
              headers[h].validation == true &&
              fields
                .filter((x) => x.key == rows[i].subTypeId.value)[0]
                .fields.filter(
                  (x) => x.toLowerCase() == headername.toLowerCase()
                ).length > 0
            ) {
              if (
                !rows[i][headername].disable &&
                  (rows[i][headername].value === "" ||
                rows[i][headername].value == "0")
              ) {
                blankdataError = true;
                this.SetErrors(rows[i], headername, true);
              } else {
                if (
                  headername == "startDate" &&
                  rows[i].startDateType.value != 0 &&
                  rows[i].startDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(Errors, typeid, subType, "Invalid Date");
                } else if (
                  headername == "endDate" &&
                  rows[i].endDateType.value != 0 &&
                  rows[i].endDate.value.length != 7
                ) {
                  Errors.hasErrors = true;
                  blankdataError = true;
                  this.SetErrors(rows[i], headername, true);
                  this.PushErrors(Errors, typeid, subType, "Invalid Date");
                } else {
                  this.SetErrors(rows[i], headername, false);
                }
              }
            }
          }
          if (blankdataError) {
            let error = "All Fields are Required";
            Errors.hasErrors = true;
            this.PushErrors(Errors, typeid, subType, error);
          }

          startMonth = CommonHelper.getMonthfromMonthYear(
            rows[i].startDate.value
          );
          startYear = CommonHelper.getYearfromMonthYear(
            rows[i].startDate.value
          );
          endMonth = rows[i].endDate
            ? CommonHelper.getMonthfromMonthYear(rows[i].endDate.value)
            : "";
          endYear = rows[i].endDate
            ? CommonHelper.getYearfromMonthYear(rows[i].endDate.value)
            : "";
          if (
            CommonHelper.compareDates(
              startYear,
              startMonth,
              "01",
              endYear,
              endMonth,
              "01"
            ) &&
            !blankdataError &&
            startMonth != "" &&
            endMonth != ""
          ) {
            Errors.hasErrors = true;
            this.SetErrors(rows[i], "startDate", true);
            this.SetErrors(rows[i], "endDate", true);
            if (!hasRangeError) {
              let Errormsg =
                "Start Date cannot be greater than or equal to End Date";
              this.PushErrors(Errors, typeid, subType, Errormsg);
            }
            hasRangeError = true;
          }
          if (
            !blankdataError && 
            fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
              .overlapvalidations
          ) {
            for (let j = 0; j < rows.length; j++) {
              if (
                i != j &&
                fields.filter((x) => x.key == rows[i].subTypeId.value)[0]
                  .overlapvalidations &&
                fields.filter((x) => x.key == rows[j].subTypeId.value)[0]
                  .overlapvalidations
              ) {
                let err =
                  "Hit 'Tab' to move to the next cell and add a new row";
                if (
                  !CommonHelper.CompareOverlappingDates(
                    startYear,
                    startMonth,
                    "01",
                    endYear,
                    endMonth,
                    "01",
                    CommonHelper.getYearfromMonthYear(rows[j].startDate.value),
                    CommonHelper.getMonthfromMonthYear(rows[j].startDate.value),
                    "01",
                    CommonHelper.getYearfromMonthYear(rows[j].endDate.value),
                    CommonHelper.getMonthfromMonthYear(rows[j].endDate.value),
                    "01"
                  ) &&
                  rows[j].startDate.value != "" &&
                  rows[j].endDate.value != ""
                ) {
                  this.SetErrors(rows[i], "startDate", true);
                  this.SetErrors(rows[i], "endDate", true);
                  Errors.hasErrors = true;
                  err =
                    "Overlapping time frame. To Proceed, review and edit to ensure no overlapping across periods";
                  this.PushErrors(Errors, typeid, subType, err);
                }
              }
            }
          }
        }
        this.infoError = Errors.hasErrors;
        if (Errors.hasErrors) {
          if (typeid == AdvanceInvestmentFilter.Return) {
            this.infoText = Errors.Return.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.InterestRate = this.infoText;
          } else if (typeid == AdvanceInvestmentFilter.Contribution) {
            this.infoText = Errors.Contribution.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Repayment = this.infoText;
          } else if (typeid == AdvanceInvestmentFilter.Withdrawal) {
            this.infoText = Errors.Withdrawal.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Drawdown = this.infoText;
          } else if (typeid == AdvanceInvestmentFilter.Maturity) {
            this.infoText = Errors.Maturity.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Drawdown = this.infoText;
          } else if (typeid == AdvanceInvestmentFilter.MarketCrash) {
            this.infoText = Errors.MarketCrash.filter(
              (item, i, ar) => ar.indexOf(item) === i
            );
            Errors.Drawdown = this.infoText;
          }
        } else {
          this.RemoveError(Errors, typeid);
          this.infoText = [];
        }
        let data = tabdata.filter((sr) => sr.typeId.value != typeid);
        let advancedetails = data.concat(rows);
        this.baselineFilterObject.advancedetails = advancedetails;
        this.baselineFilterObject.Errors = Errors;
        this.rows = this.emptyGridRow(rows);
        this.focusElementName = "";
        this.setErrorFocus();
      } else {
        this.RemoveError(Errors, typeid);
        this.baselineFilterObject.Errors = Errors;
      }
      this.getinsertEmptyRows(this.rows);

      return Errors.hasErrors;
    },

    async UpdateGraphModel() {
      await this.getProjectionResult();
      this.RemapGraphsModel();
      this.setFocus();
    },

    RemapGraphsModel() {
      if (this.projectionModel) {
        this.rightToolSummary = [
          {
            key: "Projected Balance",
            value: this.projectionModel.projectedBalance,
          },
          {
            key: "Cumulative Return",
            value: this.projectionModel.cumulativeReturn,
          },
          {
            key: "Net Contribution",
            value: this.projectionModel.netContribution,
          },
        ];
        this.chartData = {
          contributionWithdrawalGraph:
            this.projectionModel.contributionWithdrawalGraphData,
          balanceGraph: this.projectionModel.balanceGraphData,
          ReturnFeesGraph: this.projectionModel.ReturnFeesGraphData,
        };
        this.onChangeChartTab(this.selectedTabComponent);
      }
    },
    onChangeChartTab(tabId) {
      this.selectedTabComponent = tabId;
      let legendItems = [];
      let legendColors = [];
      let yAxisLabel = "Asset  Balance";
      if (this.chartData["balanceGraph"]) {
        if (this.selectedTabComponent == "balanceGraph") {
          this.selectedChartComponent = "chart-area";
          legendItems = "Balance";
          this.chartProperties = this.GetAreaChartProperties(
            this.chartData[tabId],
            legendItems,
            yAxisLabel
          );
          this.chartGraphData = this.chartData[tabId].data;
        } else if (tabId == "timelineChart") {
          this.selectedChartComponent = "chart-time-series";
          this.chartProperties = this.timeSeriesChartProperties;
          this.chartGraphData = this.timeSeriesChartData;
        } else {
          this.selectedChartComponent = "chart-bar";

          if (tabId == "contributionWithdrawalGraph") {
            legendItems = ["Contribution", "Withdrawal"];
            legendColors = ["#7999cf", "#ff6666"];
            yAxisLabel = "Contribution & Withdrawals";
          } else {
            legendItems = ["Income", "Growth", "Fees"];
            legendColors = ["#7999cf", "#f9dc66", "#ff6666"];
            yAxisLabel = "Return & Fees";
          }
          this.chartProperties = this.GetBarChartProperties(
            this.chartData[tabId],
            legendItems,
            legendColors,
            yAxisLabel
          );
          this.chartGraphData = this.chartData[tabId].data;
        }
        this.isNotShowGraph = false;
      } else {
        this.isNotShowGraph = true;
      }
    },
    getTimeSeriesCoordinate(addtionalData, filterType, projectionYear) {
      let timeseriesData = [];
      if (addtionalData == null || addtionalData.length == 0) {
        return timeseriesData;
      }
      let userinputdata = addtionalData.filter(
        (sr) => sr.typeId.value == filterType
      );
      let yearRange = this.getTimeSeriesXAxisData(projectionYear);
      if (userinputdata != undefined && userinputdata.length > 0) {
        for (let i = 0; i < userinputdata.length; i++) {
          let statYearMonth = this.getStartMonthYear(
            userinputdata[i].startDate.value,
            yearRange
          );
          let endYearMonth = this.getEndMonthYear(
            userinputdata[i].endDate.value,
            yearRange
          );
          timeseriesData.push({
            id: i,
            startMonth: statYearMonth[0],
            startYear: statYearMonth[1],
            endMonth: !endYearMonth ? statYearMonth[0] + 1 : endYearMonth[0],
            endYear: !endYearMonth ? statYearMonth[1] : endYearMonth[1],
            description: userinputdata[i].description.value,
            title: CommonHelper.convertIntoCurrencyWithoutDecimal(
              userinputdata[i].amount.value
            ),
            toolTipData:
              filterType == AdvanceInvestmentFilter.Return
                ? [
                    {
                      description: "Income",
                      title: CommonHelper.addConstantSymbolInNumber(
                        userinputdata[i].amount.value,
                        "%"
                      ),
                    },
                    {
                      description: "Growth",
                      title: CommonHelper.addConstantSymbolInNumber(
                        userinputdata[i].amount1.value,
                        "%"
                      ),
                    },
                    {
                      description: "Franking",
                      title: CommonHelper.addConstantSymbolInNumber(
                        userinputdata[i].amount2.value,
                        "%"
                      ),
                    },
                  ]
                : null,
          });
        }
      }
      return timeseriesData;
    },
    GetBarChartProperties(chartData, legendItems, legendColors, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );
      let roundOffYMinaxis =
        chartData.minYAxis > 0
          ? -CommonHelper.getRoundOffValueForAxis(
              0,
              Math.ceil(chartData.minYAxis),
              5
            )
          : 0;
      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.barChartProperties.legendItems = legendItems;
      this.barChartProperties.color = legendColors;
      this.barChartProperties.yAxisLabel = yAxisLabel;
      this.barChartProperties.domainX = [0, chartData.maxXAxis];
      this.barChartProperties.domainY = [roundOffYMinaxis, roundOffYaxis];
      return this.barChartProperties;
    },
    GetAreaChartProperties(chartData, legendItems, yAxisLabel) {
      let roundOffYaxis = CommonHelper.getRoundOffValueForAxis(
        0,
        Math.ceil(chartData.maxYAxis),
        5
      );

      if (roundOffYaxis < 5) {
        roundOffYaxis = 5;
      }
      this.areaChartProperties.areaLegendItems = legendItems;
      this.areaChartProperties.domainX = [0, this.projectionYear.Value];
      this.areaChartProperties.yAxisLabel = yAxisLabel;
      this.areaChartProperties.tickX = 0;
      this.areaChartProperties.domainY = [0, roundOffYaxis];
      return this.areaChartProperties;
    },
  },
};
